import { Link, Outlet, useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

export default function AdminLayout() {
  const { user, signOut } = useAuth();
  const navigate = useNavigate();

  const handleSignOut = async () => {
    await signOut();
    navigate('/admin/login');
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <header className="bg-navy text-white shadow-lg sticky top-0 z-40 no-print">
        <div className="max-w-7xl mx-auto px-6 py-4">
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-8">
              <Link to="/admin" className="flex items-center gap-2">
                <img
                  src="https://public.readdy.ai/ai/img_res/57c0e0b8-2118-4261-ad02-fa518c6dea96.png"
                  alt="OWHC Logo"
                  className="h-10 w-auto"
                />
                <span className="font-bebas text-xl tracking-wider">ADMIN</span>
              </Link>
              <nav className="flex gap-6">
                <Link
                  to="/admin"
                  className="font-rajdhani font-semibold text-white hover:text-martial-red transition-colors"
                >
                  Applicants
                </Link>
              </nav>
            </div>
            <div className="flex items-center gap-4">
              <span className="text-sm font-rajdhani text-white/80">{user?.email}</span>
              <button
                onClick={handleSignOut}
                className="font-rajdhani font-semibold text-martial-red hover:text-red-400 transition-colors cursor-pointer"
              >
                Sign out
              </button>
            </div>
          </div>
        </div>
      </header>

      <main className="max-w-7xl mx-auto px-6 py-8">
        <Outlet />
      </main>
    </div>
  );
}
